"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOptionsAvailable = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackOptionsAvailable(available) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        optionsAvailable: available ? '1' : '0',
    });
}
exports.trackOptionsAvailable = trackOptionsAvailable;
//# sourceMappingURL=trackOptionsAvailable.js.map